import PropTypes from 'prop-types';
import { Col, Container, Navbar, Row } from 'react-bootstrap';
import { withRouter } from 'react-router';
import styled, { useTheme } from 'styled-components';

import blueCurveSm from '../../../assets/svg/blue-curve-sm.svg';
import blueCurve from '../../../assets/svg/blue-curve.svg';
import greenCurveSm from '../../../assets/svg/green-curve-sm.svg';
import greenCurve from '../../../assets/svg/green-curve.svg';
import purpleCurveSm from '../../../assets/svg/purple-curve-sm.svg';
import purpleCurve from '../../../assets/svg/purple-curve.svg';
import yellowCurveSm from '../../../assets/svg/yellow-curve-sm.svg';
import yellowCurve from '../../../assets/svg/yellow-curve.svg';
import { useCurrentUser } from '../../../hooks';
import { signOut } from '../../../utils/auth';
import { max, min } from '../../../utils/breakpoints';
import AdminBar from '../../AdminBar';
import MainNav from '../../MainNav';

const StyledContainer = styled(Container)`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-color: ${(props) => props.theme.colors.offWhite};
  z-index: 100;
  overflow-x: hidden;
  width: 100%;
`;

const StyledNavbar = styled(Navbar)`
  padding-top: 2px;
`;

const ContentDiv = styled.div`
  z-index: 0;
`;

const CopyrightDiv = styled.div`
  font-weight: bold;
  color: ${(props) => props.theme.colors.white};
  font-size: 12px;

  ${min.sm} {
    font-size: 14px;
  }
`;

const BackgroundShapeBlue = styled(StyledContainer)`
  background-image: url(${blueCurve});

  ${max.lg} {
    background-image: url(${blueCurveSm});
  }
`;

const BackgroundShapePurple = styled(StyledContainer)`
  background-image: url(${purpleCurve});

  ${max.lg} {
    background-image: url(${purpleCurveSm});
  }
`;

const BackgroundShapeGreen = styled(StyledContainer)`
  background-image: url(${greenCurve});

  ${max.lg} {
    background-image: url(${greenCurveSm});
  }
`;

const BackgroundShapeYellow = styled(StyledContainer)`
  background-image: url(${yellowCurve});

  ${max.lg} {
    background-image: url(${yellowCurveSm});
  }
`;

const getBackgroundShape = (backgroundTint) => {
  switch (backgroundTint) {
    case 'blue':
      return BackgroundShapeBlue;
    case 'green':
      return BackgroundShapeGreen;
    case 'yellow':
      return BackgroundShapeYellow;
    case 'purple':
      return BackgroundShapePurple;
    default:
      return BackgroundShapeBlue;
  }
};

const LoopOnboardingLayout = ({ children, backgroundTint }) => {
  const theme = useTheme();
  const { user, isAdmin } = useCurrentUser();

  const BackgroundShapeDiv = getBackgroundShape(backgroundTint);

  return (
    <BackgroundShapeDiv
      fluid
      className="d-flex flex-column align-content-between justify-content-between login-background p-0 onboarding"
    >
      <div>
        {isAdmin && <AdminBar user={user} onSignOut={signOut} />}
        <Container fluid>
          <Row>
            <Col className="p-0 onboarding-nav-container">
              <StyledNavbar collapseOnSelect expand="lg" variant="dark">
                <Container fluid="xl">
                  <MainNav isLoginScreen={false} showSignOut={true} isAdmin={isAdmin} user={user} isOnboarding={true} />
                </Container>
              </StyledNavbar>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="flex-fill">
        <Container fluid="lg">
          <Row>
            <Col>
              <ContentDiv className="d-flex justify-content-center p-sm-3 p-xs-1 pt-3">{children}</ContentDiv>
            </Col>
          </Row>
        </Container>
      </div>
      <Navbar bg="dark" variant="dark" className={'pr-0 mt-5'}>
        <Container fluid="lg">
          <Row className="mx-auto py-lg-4 py-md-3">
            <Col>
              <CopyrightDiv className="pl-0 p-2 text-center">
                &copy; {new Date().getFullYear()} {theme.language.appName}. All Rights Reserved.
              </CopyrightDiv>
            </Col>
          </Row>
        </Container>
      </Navbar>
    </BackgroundShapeDiv>
  );
};

LoopOnboardingLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  backgroundTint: PropTypes.oneOf(['blue', 'green', 'purple', 'yellow']),
};

export default withRouter(LoopOnboardingLayout);
